import React from 'react';
import FrontPage from '../components/FrontPage/Component'

function FlashScreen() {
  return (
   <>
   <FrontPage/>

   
   </>
  )
}

export default FlashScreen
